// Lightweight password strength scorer. Returns { score: 0..3, label, colorClass, widthClass }.
// 0 = weak, 1 = fair, 2 = good, 3 = strong. Not a security oracle — a nudge for the user.

export function scorePassword(pw) {
  const s = pw || "";
  if (s.length < 6) return 0;
  let bits = 0;
  if (/[a-z]/.test(s)) bits += 1;
  if (/[A-Z]/.test(s)) bits += 1;
  if (/[0-9]/.test(s)) bits += 1;
  if (/[^A-Za-z0-9]/.test(s)) bits += 1;
  if (s.length >= 12) bits += 1;
  if (s.length >= 16) bits += 1;
  // Map 0..6 -> 0..3
  if (bits === 0) return 0;
  if (bits === 1) return 1;
  if (bits === 2 || bits === 3) return 2;
  return 3;
}

export const STRENGTH_META = [
  { key: "strength_weak", color: "bg-destructive", widthPct: 25 },
  { key: "strength_fair", color: "bg-yellow-500", widthPct: 50 },
  { key: "strength_good", color: "bg-primary", widthPct: 75 },
  { key: "strength_strong", color: "bg-emerald-500", widthPct: 100 },
];
